var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.24654L5.28596 4.17504L8.02009 7.41103C8.81045 5.56711 10.1144 4.10245 11.7117 3.26443L13.4515 2.3478M13.4515 2.3478L9.67987 0.634766M13.4515 2.3478L12.0038 6.81147",
    stroke: "#048848",
    strokeWidth: 1.127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseArrowIcon);
export default __webpack_public_path__ + "static/media/increase-arrow-icon.78a247c88b896a5c847823d59a6f3e93.svg";
export { ForwardRef as ReactComponent };